import { Injectable, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }

  public loadJsScript(renderer: Renderer2, scriptText?: string | null, scriptType?: string | null, scriptSrc?: string | null, id?: string | null) {
    const script = renderer.createElement('script');

    if (scriptType) {
      script.type = scriptType;
    };
    if (scriptSrc) {
      script.src = scriptSrc;
    };
    if (scriptText) {
      script.text = scriptText;
    }
    if (id) {
      script.id = id;
    }
    // Note: If a script needs to be loaded from a URL, add script.src

    renderer.appendChild(this.document.body, script);

    return script;
  }
}
